import { NgModule } from '@angular/core';
import { GooglePlaceDirective } from './google-place.directive';

@NgModule({
  declarations: [GooglePlaceDirective],
  exports: [GooglePlaceDirective],
})
export class GooglePlaceModule {}
